import axiosInstance from '../../../../common/axios.service';
import type {ADD_STATION_GROUP, UPDATE_STATION_GROUP} from './stationGroups.type';
import type FILTERS from '../../../../common/filters.type';

const addGroup = (payload: ADD_STATION_GROUP) => {
  return axiosInstance.post('stationgroup', payload).then((response) => {
    return response;
  });
};
const updateGroup = (values: {groupId: number; payload: UPDATE_STATION_GROUP}) => {
  return axiosInstance.put(`stationgroup/${values.groupId}`, values.payload).then((response) => {
    return response;
  });
};
const groupList = () => {
  return axiosInstance.get('stationgroup').then((response) => {
    return response;
  });
};
const stationGroupStations = (payload: {groupId: number; filters: FILTERS}) => {
  return axiosInstance
    .get(`stationgroup/${payload.groupId}`, {params: payload.filters})
    .then((response) => {
      return response;
    });
};

const stationGroupServices = {
  addGroup,
  updateGroup,
  groupList,
  stationGroupStations,
};

export default stationGroupServices;
